<div class="modal-header">
  <h4 class="modal-title">{{ isEditMode ? 'Edit contract' : 'Add contract' }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()"><span aria-hidden="true">&times;</span></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="form-group">
      <label>Jira/Tempo account</label>
      <select formControlName="jiraAccountId" (change)="onAccountSelect($event.target.value)">
        <option value="">-- choose account --</option>
        <option *ngFor="let a of jiraAccounts" [value]="a.accountId || a.key || a.id">
          {{ getJiraAccountOptionLabel(a) }}
        </option>
      </select>
    </div>

    <!-- Account name field removed (auto-filled from selected Jira/Tempo account) -->

    <div class="form-group">
      <label>Linked employees</label>
      <select formControlName="employeeIds" multiple>
        <option *ngFor="let employee of employees" [value]="employee.uuid">
          {{ getEmployeeOptionLabel(employee) }}
        </option>
      </select>
      <small class="form-text text-muted">Multiple employees can be linked to this account/budget.</small>
    </div>

    <div class="form-group">
      <label>Price / hour </label>
      <input type="number" formControlName="price" />
    </div>

    <div class="form-group">
      <label>Budget (€)</label>
      <input type="number" step="0.01" min="0" formControlName="budget" />
    </div>

    <div class="form-group">
      <label>
        <input type="checkbox" formControlName="includeProjectManagement" />
        +15% projectmanagement op worklogs
      </label>
    </div>

    <div class="row">
      <div class="col-6">
        <label>Effective from</label>
        <input type="date" formControlName="effectiveFrom" />
      </div>
      <div class="col-6">
        <label>Effective to</label>
        <input type="date" formControlName="effectiveTo" />
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label>Purchase order (PO)</label>
          <input type="text" formControlName="poNumber" />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>SES / invoicing approval</label>
          <input type="text" formControlName="sesNumber" />
        </div>
      </div>
    </div>

    <div class="form-group">
      <label>Contract / MSA number</label>
      <input type="text" formControlName="contractAgreementNumber" />
    </div>

    <div class="form-group">
      <label>Invoice free text</label>
      <textarea rows="3" formControlName="freeText"></textarea>
    </div>

    <div class="form-group">
      <label>Contract (optional)</label>
      <app-file-upload formControlName="contractFile" type="file"></app-file-upload>
      <button
        type="button"
        class="button button--icon m-t-1"
        [disabled]="aiExtracting"
        (click)="extractInvoiceFieldsWithAi()">
        <i class="las la-magic" aria-hidden="true"></i>
        <span>{{ aiExtracting ? 'Extracting…' : 'AI extract invoice fields' }}</span>
      </button>
      <small class="form-text text-muted">File will be uploaded and linked to the account.</small>
      <div *ngIf="form.value.contractFile" class="m-t-2">
        <small>Current file: {{ form.value.contractFile.split('/').pop() }}</small>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <app-missing-fields [form]="form"></app-missing-fields>
  <button type="button" class="button button--outline" (click)="activeModal.dismiss()">Close</button>
  <button type="button" class="button button--primary" [disabled]="!form.valid || loading" (click)="submit()">{{ isEditMode ? 'Update' : 'Save' }}</button>
</div>
